import clsx from "clsx";
import { motion } from "framer-motion";
import { Gauge, LineChart, Star } from "lucide-react";
import { Field } from "./../components/UI/fieldset.jsx";
import { Listbox, ListboxLabel, ListboxOption } from "../components/UI/listbox";

export default function Dashboard() {
  const stats = [
    { label: "Applicants", value: 15 },
    { label: "In Process", value: 10 },
    { label: "Accepted", value: 125 },
  ];

  const timeframes = ["Week", "Month", "Quarter", "Year"];

  return (
    <div className="flex h-full">
      {/* Left Column - Stats */}
      <aside className="bg-white p-6 pt-2 border-r border-gray-300 flex flex-col w-1/4">
        <nav className="space-y-4 flex-1 grid grid-rows-3 gap-6">
          {stats.map((stat) => (
            <div
              key={stat.label}
              className="bg-white shadow-md rounded-lg p-4 flex flex-col items-center justify-center h-full"
            >
              <h3 className="text-lg font-semibold text-center">{stat.label}</h3>
              <div className="w-20 h-20 flex items-center justify-center rounded-full border-4 border-marigold mt-2">
                <span className="text-3xl font-bold text-marigold">
                  {stat.value}
                </span>
              </div>
            </div>
          ))}
        </nav>
      </aside>

      {/* Right Column - Centered Dashboard Tiles */}
      <main className="flex-1 p-6 h-full flex flex-col justify-center">
        <div className="grid grid-cols-3 gap-6 auto-rows-[14rem] place-items-center">
          {/* Dashboard Tiles */}
          <div className="bg-white shadow-md rounded-lg p-4 flex flex-col items-center justify-center h-full w-full">
            <h3 className="text-lg font-semibold text-center">
              Average Days to Process
            </h3>
            <div className="w-20 h-20 flex items-center justify-center rounded-full border-4 border-marigold mt-4">
              <span className="text-3xl font-bold text-marigold">30</span>
            </div>
            <Field className={"mt-2"}>
              <Listbox defaultValue="Week">
                {timeframes.map((tf) => (
                  <ListboxOption key={tf} value={tf}>
                    <ListboxLabel>{tf}</ListboxLabel>
                  </ListboxOption>
                ))}
              </Listbox>
            </Field>
          </div>

          <div className="bg-white shadow-md rounded-lg p-4 flex flex-col items-center justify-center h-full w-full">
            <h3 className="text-lg font-semibold text-center">
              Conversion Rate
            </h3>
            <h3 className="text-lg font-semibold text-center">
              Applicants to Accepted
            </h3>
            <motion.div
              className="mt-4"
              initial={{ rotate: -30 }}
              animate={{ rotate: 30 }}
              transition={{
                repeat: Infinity,
                duration: 2,
                repeatType: "reverse",
              }}
            >
              <Gauge className="w-16 h-16" />
            </motion.div>
          </div>

          <div className="bg-white shadow-md rounded-lg p-4 flex flex-col items-center justify-center h-full w-full">
            <h3 className="text-lg font-semibold text-center">
              Confidence Rating - Training
            </h3>
            <div className="flex mt-2">
              {[...Array(5)].map((_, i) => (
                <Star
                  key={i}
                  className={clsx(
                    "w-6 h-6",
                    i < 4 ? "text-marigold" : "text-gray-400"
                  )}
                  fill={i < 4 ? "currentColor" : "none"}
                />
              ))}
            </div>
          </div>

          <div className="bg-white shadow-md rounded-lg p-4 flex flex-col items-center justify-center h-full w-full">
            <h3 className="text-lg font-semibold text-center">
              Volunteer Satisfaction
            </h3>
            <div className="flex mt-2">
              {[...Array(5)].map((_, i) => (
                <Star
                  key={i}
                  className={clsx(
                    "w-6 h-6",
                    i < 4 ? "text-marigold" : "text-gray-400"
                  )}
                  fill={i < 4 ? "currentColor" : "none"}
                />
              ))}
            </div>
          </div>

          <div className="bg-white shadow-md rounded-lg p-4 flex flex-col items-center justify-center h-full w-full">
            <h3 className="text-lg font-semibold text-center">
              Hours Per Volunteer
            </h3>
            <LineChart className="w-16 h-16 mt-4" />
            <Field className={"mt-2"}>
              <Listbox defaultValue="Week">
                {timeframes.map((tf) => (
                  <ListboxOption key={tf} value={tf}>
                    <ListboxLabel>{tf}</ListboxLabel>
                  </ListboxOption>
                ))}
              </Listbox>
            </Field>
          </div>

          <div className="bg-white shadow-md rounded-lg p-4 flex flex-col items-center justify-center h-full w-full">
            <h3 className="text-lg font-semibold text-center">
              Retention Rate
            </h3>
            <div className="w-20 h-20 flex items-center justify-center rounded-full border-4 border-marigold mt-4">
              <span className="text-3xl font-bold text-marigold">80%</span>
            </div>
            <Field className={"mt-2"}>
              <Listbox defaultValue="Week">
                {timeframes.map((tf) => (
                  <ListboxOption key={tf} value={tf}>
                    <ListboxLabel>{tf}</ListboxLabel>
                  </ListboxOption>
                ))}
              </Listbox>
            </Field>
          </div>
        </div>
      </main>
    </div>
  );
}
